import { useEffect, useState } from "react";
import { usePreferences } from "src/hooks/usePreferences";

// subscribes to changes in the system theme
export function useColorScheme() {
  const { query, mutator, theme: cache } = usePreferences();
  const preferred = query.data?.theme ?? "auto";
  const [theme, setTheme] = useState<"dark" | "light">(
    cache === "auto" ? (prefersDark() ? "dark" : "light") : cache
  );
  const target =
    preferred === "auto" ? (prefersDark() ? "dark" : "light") : preferred;
  const saving = query.isLoading || mutator.isLoading;
  useEffect(() => {
    if (!saving && theme !== target) setTheme(target);
  }, [saving, target, theme]);
  useEffect(() => {
    const changer = (event: MediaQueryListEvent) => {
      if (preferred === "auto") setTheme(event.matches ? "dark" : "light");
    };
    const matcher = window.matchMedia("(prefers-color-scheme: dark)");
    matcher.addEventListener("change", changer);
    return () => matcher.removeEventListener("change", changer);
  }, [preferred]);
  return theme;
}

function prefersDark() {
  const browser = typeof window !== "undefined";
  return (
    browser &&
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches
  );
}
